/*
 * the penalties dialogs' own checks, pure so they are unit-tested apart from the JSX. Each returns
 * { field: message } with for a valid field; the server re-validates every one.
 */
import {
  BULK_ACTION,
  DIRECTIVE_ACTION,
  DIRECTIVE_CHOICE,
  MANUAL_TYPE,
  amount_error,
  approved_by_error,
  note_error,
  parse_number,
  pct_error
} from './params';

// Which figure a session-linked add or a correction is typed in; the server derives the other.
export const MODE = { PCT: 'pct', AMOUNT: 'amount' };

const reason_error = (form) => (form.reason_code ? '' : 'Choose a reason.');

// A month-level add (MANUAL) is always by amount; an add is never zero (that would be no penalty).
export const add_form_errors = (form, mode) => {
  const month_level = form.penalty_type === MANUAL_TYPE;
  const amount = parse_number(form.amount);
  let value = '';
  if (month_level || mode === MODE.AMOUNT) {
    value = amount_error(form.amount) || (amount === 0 ? 'Enter an amount above zero.' : '');
  } else {
    value =
      pct_error(form.penalty_pct) ||
      (parse_number(form.penalty_pct) === 0 ? 'Enter a percentage above zero.' : '');
  }
  return {
    teacher_uuid: form.teacher_uuid ? '' : 'Choose a teacher.',
    penalty_type: form.penalty_type ? '' : 'Choose a penalty type.',
    session_uuid: month_level || form.session_uuid ? '' : 'Choose the session.',
    value,
    reason_code: reason_error(form),
    note: note_error(form.note)
  };
};

export const correct_form_errors = (form, mode) => ({
  value: mode === MODE.PCT ? pct_error(form.penalty_pct) : amount_error(form.amount),
  reason_code: reason_error(form),
  note: note_error(form.note)
});

// waive=false un-waives; "Approved by" is a label on a waive only.
export const waive_form_errors = (form, waive) => ({
  reason_code: reason_error(form),
  note: note_error(form.note),
  approved_by: waive ? approved_by_error(form.approved_by) : ''
});

export const bulk_form_errors = (action, form) => ({
  reason_code: reason_error(form),
  note: note_error(form.note),
  approved_by: action === BULK_ACTION.WAIVE ? approved_by_error(form.approved_by) : ''
});

export const pass_form_errors = (action, form) => ({
  move_to:
    action === DIRECTIVE_ACTION.REMOVE && form.choice === DIRECTIVE_CHOICE.MOVE && !form.move_to
      ? 'Choose the day the pass moves to.'
      : '',
  choice:
    action === DIRECTIVE_ACTION.REMOVE && !form.choice ? 'Choose what happens to the pass.' : '',
  note: note_error(form.note)
});
